(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-score/assets/javascripts/betslips/externa-systemspel.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-score/assets/javascripts/betslips/externa-systemspel.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const _svs$components$tipse = svs.components.tipsen.betslipComponents,
  Betslip = _svs$components$tipse.Betslip,
  useBetslipContext = _svs$components$tipse.useBetslipContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectTotalAmountOfRows = svs.components.tipsen.engine.selectors.couponSelectors.selectTotalAmountOfRows;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const format = svs.utils.format;
const clx = svs.components.lbUtils.clx;
const ExternaSystemspel = () => {
  const _useBetslipContext = useBetslipContext(),
    couponId = _useBetslipContext.couponId,
    isCouponValid = _useBetslipContext.isCouponValid,
    isMedium = _useBetslipContext.isMedium,
    price = _useBetslipContext.price;
  const totalAmountOfRows = useSelector(state => selectTotalAmountOfRows(state, couponId));
  const isPlayer = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const isAnonymous = svs.core.userSession.isAnonymous();
  const shouldDisplayBalance = isCouponValid && (isAnonymous || isPlayer) && !isSelfService && isMedium;
  const label = 'Rader';
  const blockName = 'pg_tipsen_betslip__content';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--valid_coupon")]: isCouponValid
  });
  return React.createElement("div", {
    className: classNames
  }, React.createElement("span", {
    className: "pg_tipsen_betslip_system_info"
  }, React.createElement(Betslip.RowsView, {
    label: label,
    numberOfRows: totalAmountOfRows
  }, React.createElement(Betslip.BetslipLabel, null))), shouldDisplayBalance && React.createElement("span", {
    className: "pg_tipsen_betslip_balance"
  }, React.createElement(Betslip.BalanceView, null)), React.createElement("div", {
    className: "pg_tipsen_betslip_price"
  }, format.Currency(price), "\xA0KR"), React.createElement("span", {
    className: "pg_tipsen_betslip_pay_button"
  }, React.createElement(Betslip.PayButton, null)));
};
setGlobal('svs.components.tipsen.betslipSelectorScore.betslips.ExternaSystemspel', ExternaSystemspel);

 })(window);